import {formatDate} from "@ui-seeker/utils";


export default function dateColumn() {
	return {
		name: 'date', label: 'Date',
		options: {
			headerAlign: 'center',
			setCellProps: () => ({ sx: { minWidth: '120px' }}),
			customBodyRowRenderLite: value => formatDate(value, { isString: true })
		}
	}
}